module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid",
    attrs: {
      "id": "presion"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "graficas"
    }
  }, [(_vm.datacollection) ? _c('div', {
    attrs: {
      "id": "line-charts"
    }
  }, [_c('line-chart', {
    ref: "chart",
    attrs: {
      "height": 400,
      "chartData": _vm.datacollection,
      "options": _vm.chartOps
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19b0c63f","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Charts/CustomLineChart.vue
// module id = 1689
// module chunks = 6